/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface RequestContactSettingFieldValueValuesInner
 */
export interface RequestContactSettingFieldValueValuesInner {
  /**
   *
   * @type {string}
   * @memberof RequestContactSettingFieldValueValuesInner
   */
  value?: string | null
}

export function RequestContactSettingFieldValueValuesInnerFromJSON(
  json: any
): RequestContactSettingFieldValueValuesInner {
  return RequestContactSettingFieldValueValuesInnerFromJSONTyped(json, false)
}

export function RequestContactSettingFieldValueValuesInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RequestContactSettingFieldValueValuesInner {
  if (json === undefined || json === null) {
    return json
  }
  return {
    value: !exists(json, 'value') ? undefined : json['value']
  }
}

export function RequestContactSettingFieldValueValuesInnerToJSON(
  value?: RequestContactSettingFieldValueValuesInner | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    value: value.value
  }
}
